// extracted by mini-css-extract-plugin
var _1 = "R6T_qIqZDtbV_TBIA3XI";
var _2 = "WVjemS0kq7um056lPDjW";
var _3 = "Brh5A5eTVjmNZK12R6fq";
export { _1 as "closed", _2 as "details", _3 as "report" }
